export default "__VITE_ASSET__02576b27__"